<template>
  <div class="relative">
    <img
      v-if="src && !error"
      :style="avatarSize"
      class="inline-block rounded-full ring-2 ring-white object-cover"
      :src="src"
      alt="Image Description"
      @error="imgError"
    />
    <span
      v-else
      :style="avatarSize"
      class="inline-flex items-center justify-center rounded-full bg-gray-600"
    >
      <span
        :style="{
          'font-size': `${Math.ceil((parseInt(size) / 50) * 16)}px`,
        }"
        class="font-medium text-white leading-none"
      >
        {{ getFirstLetter(name, ' ', 2) }}
      </span>
    </span>
    <span
      v-if="badge"
      class="absolute bottom-[2px] right-0 border-[2px] border-white inline-block rounded-full"
      :style="{
        width: `${Math.ceil((parseInt(size) / 50) * 12)}px`,
        height: `${Math.ceil((parseInt(size) / 50) * 12)}px`,
      }"
      :class="[isOnline ? 'bg-online' : 'bg-grey-separator']"
    ></span>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
  src: {
    type: String,
    default: '',
  },
  size: {
    type: [String, Number],
    default: '',
  },
  isOnline: {
    type: Boolean,
    default: true,
  },
  badge: {
    type: Boolean,
    default: true,
  },
  name: {
    type: String,
    default: '',
  },
});

const error = ref(false);
const imgError = () => {
  error.value = true;
};

const avatarSize = computed(() => {
  const size = props.size + 'px';
  return {
    minWidth: size,
    width: size,
    minHeight: size,
    height: size,
  };
});

const getFirstLetter = (
  name,
  divided = null,
  initialLetters = 1,
  fromLetter = 0
) => {
  if (!name) return '';
  let result = name;

  if (divided !== null) {
    result = name
      .split(divided)
      .map((el) => el[0])
      .join('');
  }

  return result.substring(fromLetter, initialLetters).toUpperCase();
};
</script>

<style scoped></style>
